import _ from 'underscore';
import Backbone from 'backbone';

import Suggestion from '../../view/suggestion';

import { idgen } from '../../utils/idgen';

const suggestions = {};
const listener = _.extend( {}, Backbone.Events );

export { suggest };

function suggest($el, selector, optionsFn, chooseFn, blurFn, hoverFn, options = {}) {
    const open = _.debounce( () => suggestion( $el.find( selector ) ).suggest(), 250 );

    bindEvents();

    return {
        hideSuggestion: () => hideSuggestion( $el.find( selector ) ),
        bindEvents,
        unbindEvents,
    }

    function chooseSuggestion($htmlInput, title, option) {
        if (chooseFn)
            chooseFn($htmlInput, title, option);

        hideSuggestion( $htmlInput );
    }

    function hideSuggestion($htmlInput) {
        suggestion( $htmlInput ).$el.remove();
    }

    function suggestion($htmlInput) {
        const htmlInput = $htmlInput[0];
        const guid = htmlInput.dataset.guid = 
            htmlInput.dataset.guid || idgen();

        if (suggestions[guid])
            return suggestions[guid].undelegateEvents(),
                suggestions[guid].delegateEvents(),
                suggestions[guid];
        
        const suggestionView = suggestions[guid] = new Suggestion( {
            optionsFn: page => {
                const result = optionsFn( $htmlInput, page, suggestionView.firstSearch );
                suggestionView.$el.insertAfter( $htmlInput );
                return result;
            },
            ...options,
        } );

        suggestionView.firstSearch = true;

        listener.listenTo( suggestionView, 'choose', 
            (title, option) => chooseSuggestion( $htmlInput, title, option ) );

        listener.listenTo( suggestionView, 'hover',
            _.debounce( makeHoverHandler( suggestionView ), 100 ) );

        return suggestionView;
    }

    function makeHoverHandler(suggestionView) {
        return (item, items, index) => {
            if (hoverFn) 
                if (Backbone.$.contains( document.body, suggestionView.el ))
                    hoverFn( item, items, index ); 
        };
    }

    function bindEvents() {
        $el.on( 'keyup', selector, onKeyUp )
            .on( 'keydown', selector, onKeyDown )
            .on( 'focus', selector, onFocus )
            .on( 'blur', selector, onBlur );
    }

    function unbindEvents() {
        $el.off( 'keyup', selector, onKeyUp )
            .off( 'keydown', selector, onKeyDown )
            .off( 'focus', selector, onFocus )
            .off( 'blur', selector, onBlur );
    }

    function onKeyUp(e) {
        if (e.keyCode === 33) return;
        if (e.keyCode === 34) return;
        if (e.keyCode === 37) return;
        if (e.keyCode === 38) return;
        if (e.keyCode === 39) return;
        if (e.keyCode === 40) return;
        if (e.keyCode === 9) return; // tab
        if (e.keyCode === 16) return; // shift
        if (e.keyCode === 17) return; // ctrl
        
        const $htmlInput = $el.find( e.currentTarget );

        if (e.keyCode === 13) {
            suggestion( $htmlInput ).chooseCurrent();

            e.preventDefault();
            return false;
        }

        suggestion( $htmlInput ).firstSearch = false;

        open();
    }

    function onKeyDown(e) {
        const $htmlInput = $el.find( e.currentTarget );

        // to make search, add suggestion to DOM first
        // (maybe removed in hideSuggestion() call)
        const suggestionView = suggestion( $htmlInput );
        if (!$.contains( document.body, suggestionView.el)) {
            suggestionView.$el.insertAfter( $htmlInput );
            suggestionView.firstSearch = false;

            // ignore control keys in this case
            if (e.keyCode === 33) return;
            if (e.keyCode === 34) return;
            if (e.keyCode === 37) return;
            if (e.keyCode === 38) return;
            if (e.keyCode === 39) return;
            if (e.keyCode === 40) return;
            if (e.keyCode === 9) return; // tab
            if (e.keyCode === 16) return; // shift
            if (e.keyCode === 17) return; // ctrl
        }

        if (e.keyCode === 33) {
            suggestion( $htmlInput ).pageUp();
            e.preventDefault();
        }

        if (e.keyCode === 34) {
            suggestion( $htmlInput ).pageDown();
            e.preventDefault();
        }

        if (38 === e.keyCode) {
            suggestion( $htmlInput ).prevItem();
            e.preventDefault();
        } 
        
        if (40 === e.keyCode) {
            suggestion( $htmlInput ).nextItem();
            e.preventDefault();
        }
    }

    function onFocus(e) {
        const $htmlInput = $el.find( e.currentTarget );
        $htmlInput[0].select();
        suggestion( $htmlInput ).open();
    }

    function onBlur(e) {
        const {relatedTarget} = e,
            $relatedTarget = Backbone.$( relatedTarget );

        if ($relatedTarget.is( '.__page-up' ) || $relatedTarget.is( '.__page-down' ))
            return e.preventDefault(), false;

        const $htmlInput = $el.find( e.currentTarget );

        if (blurFn)
            blurFn( $htmlInput );
        hideSuggestion( $htmlInput );

        const suggestionView = suggestion( $htmlInput );
        suggestionView.firstSearch = true;
    }
}




// WEBPACK FOOTER //
// ./src/js/ui/helpers/suggest.js